
import { TransferAssetApproverEntityDecoratorBase } from './transfer-asset-approver.decorator.base';


export class TransferAssetApproverEntityDecorator extends TransferAssetApproverEntityDecoratorBase {
  constructor() {
    super();
  }
}



